import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { buildApiUrl, API_ENDPOINTS } from "../config/api";

export default function PrivateRouteAdmin({ children }) {
  const [status, setStatus] = useState(null); // null=cargando | "ok" | "forbidden" | "unauth"

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const response = await fetch(buildApiUrl(API_ENDPOINTS.current), {
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        });

        if (!response.ok) {
          localStorage.removeItem("userType");
          setStatus("unauth");
          return;
        }

        const data = await response.json();
        const type = data?.datosUsuario?.type;

        // Sincronizar localStorage para que el menú refleje el rol correcto
        if (type) localStorage.setItem("userType", type);

        setStatus(type === "admin" ? "ok" : "forbidden");
      } catch {
        setStatus("unauth");
      }
    };

    checkAccess();
  }, []);

  if (status === null) return <div>Verificando autenticación...</div>;
  if (status === "unauth") return <Navigate to="/login" replace />;
  if (status === "forbidden") return <Navigate to="/" replace />;

  return children;
}
